const WIDTH_CELL = 250;
const WIDTH_TITTLE = 400;

const validateElement = (element) => {
  return typeof element !== 'undefined' ? element : 0;
};

export const parseArrToGridExcel = (arr) => {
  const header = [
    {'value': 'FAMILIA MODELO', 'width': WIDTH_TITTLE, 'readOnly': true},
    {'value': 'NORMAL', 'width': WIDTH_CELL, 'readOnly': true},
    {'value': 'EXONERADO', 'width': WIDTH_CELL, 'readOnly': true},
    {'value': 'TOTAL', 'width': WIDTH_CELL, 'readOnly': true},
  ];
  
  const result = arr.map((element) => {
    return (
      [
        {'value': element.name, 'width': WIDTH_TITTLE, 'readOnly': true},
        {'value': validateElement(element.normal), 'width': WIDTH_CELL},
        {'value': validateElement(element.exonerated), 'width': WIDTH_CELL},
        {'value': validateElement(element.total), 'width': WIDTH_CELL, 'readOnly': true},
      ]
    );
  });

  return [header, ...result];
};

